import { Children, Fragment } from 'react';

import styles from './breadcrumbs.module.less';

import type { BreadcrumbsComponent } from './breadcrumbs-types';

/**
 * @deprecated Use `Breadcrumbs` from `@mantine/core` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 */
export const Breadcrumbs: BreadcrumbsComponent = ({ children, separator = '/' }) => {
  const childrenArray = Children.toArray(children);

  return (
    <nav className={styles.breadcrumbs}>
      <ol className={styles['breadcrumbs-list']}>
        {childrenArray.map((child, index) => (
          <Fragment key={index}>
            <li>{child}</li>
            {index < childrenArray.length - 1 && (
              <span aria-hidden className={styles['breadcrumbs-separator']}>
                {separator}
              </span>
            )}
          </Fragment>
        ))}
      </ol>
    </nav>
  );
};
